// Hidden feature switches, persisted per device in localStorage.
//
// LAVA FLOOR AUTO MODE — when ON, "The floor is lava" (gameId 6) is refereed
// automatically by the LED floor (LavaFloorPage drives the floor over its
// HTTP API and decides the round winner from the measured times). When OFF
// (the default) the game uses the classic manual flow (DecideWinnerPage),
// like every other game.
//
// How to unlock on a device: on the LOGIN screen (the one asking for the
// daily 12X4YZ code) type the code below instead — a small confirmation
// appears and the mode toggles ON/OFF. Then log in normally.

const KEY = "lavaFloorAutoMode";

export const LAVA_UNLOCK_CODE = "lavax9t42mk7";

export const isLavaAutoEnabled = () => localStorage.getItem(KEY) === "on";

export const setLavaAutoEnabled = (on: boolean) => {
  if (on) localStorage.setItem(KEY, "on");
  else localStorage.removeItem(KEY);
};

// "The floor is lava" in the Versus backend (room 6). The QR code's gameName
// may be localized, so the routing checks the id as well as the name.
export const LAVA_GAME_ID = 6;
export const isLavaGame = (gameId: unknown, gameName: unknown) =>
  Number(gameId) === LAVA_GAME_ID ||
  /lav[aă]/i.test(String(gameName || ""));
